import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {Box, Colors, Text} from "@bounce/shared/ui";

export const SEGMENT_TYPE_SEPARATOR_HEIGHT = 34;

const ICON_SIZE = 14;
const BLOCKED_LABEL = "Can't drag across";

type Props = {
  isBlocked: boolean;
};

export const SegmentTypeSeparator = ({isBlocked}: Props) => {
  const textColor = isBlocked ? Colors.red._900 : Colors.grey._600;
  const lineColor = isBlocked ? Colors.red._400 : Colors.tertiary._400;
  const iconSx = {fontSize: ICON_SIZE};

  const label = (content: React.ReactNode) => (
    <Box sx={{display: "flex", alignItems: "center", gap: 0.5, whiteSpace: "nowrap", color: textColor}}>{content}</Box>
  );
  const dashedLine = <Box sx={{flex: 1, borderTop: `1px dashed ${lineColor}`}} />;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: SEGMENT_TYPE_SEPARATOR_HEIGHT,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        backgroundColor: isBlocked ? Colors.red._100 : Colors.tertiary._100,
        borderTop: `1px solid ${isBlocked ? Colors.red._400 : Colors.tertiary._300}`,
        borderBottom: `1px solid ${isBlocked ? Colors.red._400 : Colors.tertiary._300}`,
        transition: "background-color 0.15s, border-color 0.15s",
        pointerEvents: "none",
      }}
    >
      {dashedLine}
      {label(
        <>
          <LockOutlinedIcon sx={iconSx} />
          <Text size={12} sx={{color: "inherit"}}>
            {BLOCKED_LABEL}
          </Text>
        </>
      )}
      {dashedLine}
    </Box>
  );
};
